class VliscoPDPDeliveries {
    constructor() {
        this.options = {
            pdpEstimate: '.vlisco-pdp__estimate'
        };

        this.updateEstimatedDelivery();
    }

    updateEstimatedDelivery() {
        const parentEl = document.querySelector(this.options.pdpEstimate);
        const dateEl = parentEl?.querySelector('[data-date]');
        const minMaxDeliveryDays = dateEl?.dataset?.minMax?.trim() || undefined;

        if (!minMaxDeliveryDays) {
            parentEl?.classList.add('opacity-0 pointer-events-none');
        }

        const min = minMaxDeliveryDays?.split('-')[0];
        const max = minMaxDeliveryDays?.split('-')[1];

        if (!min || !max) return;

        const fromDate = this.getEstimatedDeliveryDate(new Date(), min);
        const toDate = this.getEstimatedDeliveryDate(new Date(), max);

        dateEl.innerText = `${ fromDate } - ${ toDate }`;
    }

    getEstimatedDeliveryDate(startDate, days) {
        const dayOfTheWeek = startDate.getDay();
        let daysToAdd = parseInt(days, 10);

        if (dayOfTheWeek == 0)
            daysToAdd++;
        if (dayOfTheWeek + daysToAdd >= 6) {
            const remainingWorkDays = daysToAdd - (5 - dayOfTheWeek);

            daysToAdd += 2;

            if (remainingWorkDays > 5) {
                daysToAdd += 2 * Math.floor(remainingWorkDays / 5);

                if (remainingWorkDays % 5 == 0) {
                    daysToAdd -= 2;
                }
            }
        }

        startDate.setDate(startDate.getDate() + daysToAdd);

        const dateParts = startDate.toString().split(' ');
        return `${ dateParts[0] }, ${ dateParts[1] } ${ dateParts[2] }`;
    }
}

document.addEventListener('DOMContentLoaded', () => new VliscoPDPDeliveries());
